import { cn } from "../lib/utils";

export interface SearchBoxProps {
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  width?: number | string;
  className?: string;
}

export function SearchBox({
  value,
  onChange,
  placeholder = "검색",
  width = 200,
  className,
}: SearchBoxProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-2 h-[34px] px-3 border border-border-strong rounded-base bg-surface",
        className,
      )}
      style={{ width }}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="text-ink-subtle flex-shrink-0"
      >
        <circle cx="11" cy="11" r="7" />
        <path d="m21 21-4.3-4.3" />
      </svg>
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="flex-1 text-xs bg-transparent outline-none text-ink placeholder:text-ink-subtle"
      />
    </div>
  );
}
